import palette from '../../palette';
import MuiInputBase from './MuiInputBase';
import Color from "color";

export default {
  root: {
    backgroundColor: palette.white,
    borderRadius: "4px",
    border: `1px solid ${palette.grayText}`,
    ['@media (max-width: 768px)']: {
      border: `1px solid ${palette.grayDisable}`,
    },
    "&:hover": {
      border: `1px solid ${palette.grayText}`,
    },
    "&$focused": {
      border: `1px solid ${palette.blueMain}`,
    },
    "&$error" : {
      border: `1px solid ${palette.redError}`,
      backgroundColor: Color(palette.redError).alpha(0.1).string(),
    },
    "&$disabled" : {
      borderColor: palette.grayBg,
      backgroundColor: palette.grayBg
    }
  },
  notchedOutline: {
    border: "none"
  },
  input: MuiInputBase.input
};
